<template>
  <form name="form" v-on:submit.prevent="submit" v-on:change="changeHandler">
    <fieldset
      :disabled="readonly"
      style="border:0;padding:0;margin:0;min-width:0;"
    >
      <div class="card-body">
        <div class="text-right" v-if="!readonly">
          <form-button :indicator="form.processing()" v-on:clicked="submit"
            >Save</form-button
          >
        </div>
        <div class="clearfix"></div>
        <hr />
        <div class="card-body-overlay" v-if="!Object.keys(client).length">
          Please complete the "Client Details" section before the clients
          insurance.
        </div>

        <div class="row">
          <div class="col-lg-6">
            <selectlist
              :options="insurers"
              :value="form.insurer_id"
              label="Insurer"
              helper="Please select the clients insurer"
              label-name="name"
              placeholder="Please Select"
              name="insurer"
              :show-error="form.errors.has('insurer')"
              @input="setInsurer"
            ></selectlist>

            <inputbox
              v-model="form.email"
              name="email"
              label="Email"
              helper="Please enter an email address for the insurer"
              :show-error="form.errors.has('email')"
            ></inputbox>

            <inputbox
              v-model="form.telephone"
              name="telephone"
              label="Phone"
              helper="Please enter a contact number for the insurer"
              :show-error="form.errors.has('telephone')"
            ></inputbox>
          </div>
          <div class="col-lg-6">
            <inputbox
              v-model="form.policy"
              name="policy"
              label="Policy Number"
              helper="Please enter the insurance policy number for the client"
              :show-error="form.errors.has('policy')"
            ></inputbox>

            <inputbox
              v-model="form.claim_number"
              name="claim_number"
              label="Claim Number"
              helper="Please enter any relevant insurance claim  number for the client"
              :show-error="form.errors.has('claim_number')"
            ></inputbox>

            <selectlist
              :options="coverLevels"
              v-model="form.cover_level_id"
              label="Cover Level"
              placeholder="Please Select"
              name="cover_level"
              helper="Please select the level of cover the client has"
              :show-error="form.errors.has('cover_level_id')"
            ></selectlist>

            <toggleswitch
              :labels="true"
              name="policy_validated"
              label="Policy Validated"
              v-model="form.policy_validated"
              helper="Please confirm the policy has been validated"
            ></toggleswitch>
          </div>
        </div>
      </div>
      <div class="card-footer text-right" v-if="!readonly">
        <form-button :indicator="form.processing()" v-on:clicked="submit"
          >Save</form-button
        >
      </div>
    </fieldset>
  </form>
</template>
<script>
export default {
  props: {
    incident: {
      type: String,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      form: new window.Form({
        using_own: false,
        insurer_id: '',
        email: '',
        telephone: '',
        policy: null,
        claim_number: null,
        cover_level_id: '',
        policy_validated: null
      }),
      data_entered: false
    };
  },

  mounted() {
    this.mount();
  },

  computed: {
    client() {
      return this.$store.getters['Incident/client'];
    },

    insurers() {
      return this.$store.getters['Insurers/all'];
    },

    coverLevels() {
      return this.$store.getters['CoverLevels/all'];
    }
  },

  methods: {
    mount() {
      if (Object.keys(this.client).length && this.client.insurance) {
        this.form.using_own = this.client.insurance.using_own;
        this.form.insurer_id = this.client.insurance.insurer_id;
        this.form.email = this.client.insurance.email;
        this.form.telephone = this.client.insurance.telephone;
        this.form.policy = this.client.insurance.policy;
        this.form.claim_number = this.client.insurance.claim_number;
        this.form.cover_level_id = this.client.insurance.cover_level_id;
        this.form.policy_validated = this.client.insurance.policy_validated;
      }
    },

    /**
     * If the user tries to change tab when there are unsaved changes in the form we
     * want to display a popup warning them they have unsaved changes.
     *
     * To do that we add a form @change event listener to the form and then emit an
     * 'unsaved-data' event whenever a form value changes. This is then picked up
     * in the parent component and that handles displaying the warning if the user
     * tries to change tabs.
     */
    changeHandler() {
      if (!this.data_entered) {
        this.data_entered = true;
      }
      this.$emit('unsaved-data', this.data_entered);
    },

    submit() {
      if (this.readonly) return;
      window.toastify.info('Saving', "We're saving those details for you.");

      this.form
        .post(
          `/incidents/${this.incident}/client/${this.client.identifier}/insurance`
        )
        .then(response => {
          window.toastify.success(
            'Saved',
            "We've updated those details for you."
          );
          // reset monitoring of form changes
          this.data_entered = false;
          this.$emit('unsaved-data', this.data_entered);
          this.$store.commit('Incident/setClientInsurance', response);
        })
        .catch(error => {
          window.toastify.error(
            'Error',
            'Sorry, there was an error saving the insurance details.'
          );
        });
    },

    setInsurer(value) {
      // Check if the insurer has changed, this fixes an issue on the initial
      // load where the saved insurer contact details were being overridden
      if (value != this.form.insurer_id) {
        this.form.insurer_id = value;

        const insurer = this.insurers.find(i => i.id == value);

        // If the insurer is matched set the contact details to their
        // defaults
        if (insurer) {
          this.form.email = insurer.email;
          this.form.telephone = insurer.telephone;
        }
      }
    }
  },

  watch: {
    $route(to, from) {
      this.mount();
    }
  }
};
</script>
